import React from 'react'
import './style.css'
import Button from '../../CtaButton'
import AuraButtonGreen from '../AuraButton/AuraButtonGreen'

const AuraBusinessChallenges = ({ mainHeading, description, content }) => {
    return (
        <>
            <div className="bussiness-chalanges-main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="bussiness-chalanges-section-conent aura-business-challenges">
                                <h4>{mainHeading}</h4>
                                <p className="description-text mb-3">{description}</p>
                                <AuraButtonGreen text='Learn More' link='/contact-us' />
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-6 col-md-12">
                            {content?.map((item, index) => {
                                return <div className="aura-business-challenges-content-side" key={index}>
                                    <h4>{item?.title}</h4>
                                    <p className="description-text">{item?.description}</p>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuraBusinessChallenges